import ApiClient from './apiClient'
import { QueriesApi } from './apiTypes'


const volumeTypesService = {
  getTypeList:(queries:QueriesApi) => ApiClient.get('openstack/volumetypes', {
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search
    }
  }),
  getType:(typeId:string) => ApiClient.get(`openstack/volumetypes/${typeId}`),
  createType:(data:any) => ApiClient.post(`openstack/volumetypes`, data),
  updateType:(typeId:string, data:any) => ApiClient.put(`openstack/volumetypes/${typeId}`, data),
  deleteType:(typeId:string) => ApiClient.delete(`openstack/volumetypes/${typeId}`),
  getCreateOptions:() => ApiClient.get(`openstack/volumetypes/create_options`),
}

export default volumeTypesService
